
import { Component, Prop, Vue } from 'vue-property-decorator'
import SidemenuLayout from '@/components/organisms/layout/SidemenuLayout.vue'
import NoticePanel from '@/components/organisms/topPagePanel/NoticePanel.vue'
import DailyProblemPanel from '@/components/organisms/topPagePanel/DailyProblemPanel.vue'
import RecommendLearningMapPanel from '@/components/organisms/topPagePanel/RecommendLearningMapPanel.vue'
import StudySummaryPanel from '@/components/organisms/topPagePanel/StudySummaryPanel.vue'
import StudentPanel from '@/components/organisms/topPagePanel/StudentPanel.vue'
import TopPageStudyCategory from '@/components/organisms/TopPageStudyCategory.vue'
import { NoticeMessageData } from '@/models/NoticeMessage'
import { LearningStatusCurriculumUnit, DailyUserReviewProblemCurriculumUnit } from '@/models/CurriculumUnit'
import { StudyCategory } from '@/models/StudyCategory'

/**
 * トップページのレイアウト
 */
@Component({
  components: {
    SidemenuLayout,
    NoticePanel,
    DailyProblemPanel,
    RecommendLearningMapPanel,
    StudySummaryPanel,
    StudentPanel,
    TopPageStudyCategory,
  },
})
export default class TopPageLayout extends Vue {
  // === 生徒情報パネル ===
  /** コインボタン押下時のイベント */
  @Prop()
  private eventClickCoinButton!: () => void

  /** 履歴ボタン押下時のイベント */
  @Prop()
  private eventClickHistoryButton!: () => void

  // === 学習状況サマリー ===
  // === N_LMS-282/N_LMS-283: 講習会および入試直前トレーニング実装時に該当のコメントアウトを外す

  /** 通常授業サポート学習の通算演習回数 */
  @Prop()
  private countTimesGeneralStudy!: number

  /** 講習会トレーニングの通算演習回数 */
  // @Prop()
  // private countTimesSeminarStudy!: number

  /** 入試直前トレーニングの通算演習回数 */
  // @Prop()
  // private countTimesEntranceStudy!: number

  /** 通常授業サポート学習詳細ボタン押下時のイベント */
  @Prop()
  private eventClickGeneralButton!: () => void

  /** 講習会トレーニング詳細ボタン押下時のイベント */
  // @Prop()
  // private eventClickSeminarButton!: () => void

  /** 入試直前トレーニング詳細ボタン押下時のイベント */
  // @Prop()
  // private eventClickEntranceButton!: () => void

  // === お知らせ ===

  /** 新着メッセージのリスト */
  @Prop()
  private noticeList!: NoticeMessageData[]

  /** お知らせボックス押下時のイベント */
  @Prop()
  private eventClickNotice!: (id: number) => void

  // === 知識マップのおすすめ単元 ===

  /** おすすめ単元情報(IDは増進堂単元ID) */
  @Prop()
  private recommendZnCurriculumUnits!: LearningStatusCurriculumUnit[] | null

  /** 項目ボックスクリック時のイベント */
  @Prop()
  private eventClickRecommendZnCurriculumUnit!: (id: number) => void

  // === 今日やる問題 ===

  /** 今日やる問題一覧 */
  @Prop()
  private dailyProblemList!: DailyUserReviewProblemCurriculumUnit[] | null

  /** 項目ボックスクリック時のイベント */
  @Prop()
  private eventClickDailyProblem!: (curriculumUnitId: number) => void

  // === 通常授業サポート学習 ===

  /** 通常授業サポート学習教材情報 */
  @Prop()
  private generalStudyCategoryList!: StudyCategory.LearningStatusStudyCategory[]

  /** 通常授業サポート学習教材クリック時のイベント */
  @Prop()
  private eventClickGeneralStudyCategory!: (studyCategoryId: number) => void

  // === 講習会トレーニング ===
  // === N_LMS-282: 実装時にコメントアウトを外す ===

  /** 講習会トレーニング学習教材情報 */
  // @Prop()
  // private seminarStudyCategoryList!: StudyCategory.LearningStatusStudyCategory[]

  /** 講習会トレーニング教材クリック時のイベント */
  // @Prop()
  // private eventClickSeminarStudyCategory!: (id: number) => void

  // === 入試直前トレーニング ===
  // === N_LMS-283: 実装時にコメントアウトを外す ===

  /** 入試直前トレーニング教材情報 */
  // @Prop()
  // private entranceStudyCategoryList!: StudyCategory.LearningStatusStudyCategory[]

  // /** 入試直前トレーニング教材クリック時のイベント */
  // @Prop()
  // private eventClickEntranceStudyCategory!: (id: number) => void
}
